<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="componentreplaceables_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="80">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="prod_id" [ttModel]="setting.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="setting.prod_name" ttReadonly></tt-input>
        <tt-input ttLabel="component_id" [ttModel]="setting.component_id" ttReadonly></tt-input>
        <tt-input ttLabel="component_name" [ttModel]="setting.component_name" ttReadonly></tt-input>
        <tt-button-save ttText="componentreplaceables_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>
